import { ChevronDown } from '@peacecover/icon';
import { t } from 'i18next';
import { isEmpty } from 'lodash';

interface PhotoCardFilterButtonProps {
  selectedPhotoCardCategories: string[];
  selectedEventIds: string[];
  onlyIdentityVerified: boolean;
  onClick: () => void;
}

const PhotoCardFilterButton = ({
  selectedPhotoCardCategories,
  selectedEventIds,
  onlyIdentityVerified,
  onClick
}: PhotoCardFilterButtonProps) => {
  const isChecked =
    onlyIdentityVerified || !isEmpty(selectedPhotoCardCategories) || !isEmpty(selectedEventIds);

  const getLabel = () => {
    if (!isChecked) return t('photoCardPage.photoCardType');

    let firstLabel: string;
    if (!isEmpty(selectedPhotoCardCategories)) {
      firstLabel = t(`PhotoCardFilterBottomDrawer.${selectedPhotoCardCategories[0]}Category`);
    } else if (onlyIdentityVerified) {
      firstLabel = t('TradingPhotoCardFilterBottomDrawer.identityVerifiedTitle');
    } else {
      firstLabel = t('TradingPhotoCardFilterBottomDrawer.eventTitle');
    }

    const extraCount =
      (selectedPhotoCardCategories.length > 0 ? selectedPhotoCardCategories.length - 1 : 0) +
      selectedEventIds.length +
      (onlyIdentityVerified && !isEmpty(selectedPhotoCardCategories) ? 1 : 0);

    return extraCount > 0 ? `${firstLabel} 외...` : firstLabel;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-[4px] px-[12px] py-[8px] rounded-full ${
        isChecked
          ? 'bg-secondary-light dark:bg-secondary-dark'
          : 'bg-background-elevated ring-1 ring-inset ring-separator1'
      }`}
    >
      <span
        className={`text-[14px] font-semibold truncate max-w-[80px] ${
          isChecked ? 'text-primary-light dark:text-primary-dark' : 'text-text-main-lv2'
        }`}
      >
        {getLabel()}
      </span>
      <ChevronDown
        size={14}
        className={`flex-shrink-0 ${isChecked ? 'text-on-secondary' : 'text-text-main-lv2'}`}
      />
    </button>
  );
};

export default PhotoCardFilterButton;
